import Vue from 'vue';
import store from '@/store';
import { ActionError as userStoreErr } from '@/store/user/types';
import { Route } from './types';

import { refresh as REFRESH } from '@/const/terms/feedback/user';
import { ownApiPreCheck, externalApiPreCheck} from '@/utils/api';

/** check if token is valid, and the required values are ready.*/
export async function checkLogin(): Promise<boolean> {
    if (store.getters['User/IS_LOGIN']()) {
        try {
            if (await ownApiPreCheck()) {
                return await externalApiPreCheck();
            } else {
                await store.dispatch('User/LOGOUT')
            }
        } catch (err) {
            switch (err.type) {
                case userStoreErr.VUEX_SET_USER:
                    Vue.prototype.$notify.error({message: REFRESH.error.fail, title: REFRESH.error.title});
                    Vue.prototype.customRouterErrorHandler(err, 'Vuex Set User FATAL ERROR');
                    break;
                case userStoreErr.VUEX_CLEAR_USER:
                    Vue.prototype.$notify.error({message: REFRESH.error.fail, title: REFRESH.error.title});
                    Vue.prototype.customRouterErrorHandler(err, 'Vuex Clear User FATAL ERROR');
                    break;
                default: break;
            }
            return false;
        }
    } else if (
        store.state.User.keepLogin && store.state.User.token !== ''
    ) {
        try {
            await store.dispatch('User/REFRESH_TOKEN');
        } catch (err) {
            switch (err.type) {
                case userStoreErr.HTTP_LOGIN_RESPONSE_NOT_MATCHED:
                    Vue.prototype.$notify.error({message: REFRESH.error.httpRefresh, title: REFRESH.error.title});
                    break;
                case userStoreErr.HTTP_REFRESH:
                    Vue.prototype.$notify.error({message: REFRESH.error.httpRefresh, title: REFRESH.error.title});
                    Vue.prototype.customRouterErrorHandler(err, 'HTTP Token Refresh FATAL ERROR');
                    break;
                case userStoreErr.VUEX_SET_USER:
                    Vue.prototype.$notify.error({message: REFRESH.error.fail, title: REFRESH.error.title});
                    Vue.prototype.customRouterErrorHandler(err, 'Vuex Set User FATAL ERROR');
                    break;
                case userStoreErr.VUEX_CLEAR_USER:
                    Vue.prototype.$notify.error({message: REFRESH.error.fail, title: REFRESH.error.title});
                    Vue.prototype.customRouterErrorHandler(err, 'Vuex Clear User FATAL ERROR');
                    break;
                default: break;
            }
            try {
                await store.dispatch('User/LOGOUT')
            } catch (err) {
                switch (err.type) {
                    case userStoreErr.VUEX_CLEAR_USER: 
                        Vue.prototype.customRouterErrorHandler(err, 'Vuex Clear User FATAL ERROR');
                    break;
                }
                return false;
            }
            return false;
        }

        if (await ownApiPreCheck()) {
            return await externalApiPreCheck();
        } else {
            try {
                await store.dispatch('User/LOGOUT')
            } catch (err) {
                switch (err.type) {
                    case userStoreErr.VUEX_CLEAR_USER: 
                        Vue.prototype.customRouterErrorHandler(err, 'Vuex Clear User FATAL ERROR');
                    break;
                }
                return false;
            }
        };
    }
    return false;
}

export function CoverAndInheritMeta(routes: Route[], meta = {}) {
    routes.forEach((route: Route) => {
        route.meta = Object.assign(clone(meta), (route.meta || {}));
        if (Array.isArray(route.children)) {
            CoverAndInheritMeta(route.children, route.meta);
        }
    });
}


function clone(obj: object) {
    return JSON.parse(JSON.stringify(obj));
}
